import { render, staticRenderFns } from "./smodify.vue?vue&type=template&id=8c061926&scoped=true"
import script from "./smodify.vue?vue&type=script&lang=js"
export * from "./smodify.vue?vue&type=script&lang=js"
import style0 from "./smodify.vue?vue&type=style&index=0&id=8c061926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c061926",
  null
  
)

export default component.exports